export interface ListedFile {
  name: string;
  size: number;
}

interface Props {
  folderName: string;
  files: ListedFile[];
  mode: "sharepoint" | "local" | "single";
  showFiles?: boolean;
}

export function FileList({ folderName, files, mode, showFiles = true }: Props) {
  const totalMB = files.reduce((sum, f) => sum + f.size, 0) / 1024 / 1024;

  return (
    <div className="card">
      <div className="mb-4">
        <h2 className="text-lg font-semibold">
          {mode === "single" ? folderName : `Ordner: ${folderName}`}
        </h2>
        <p className="text-sm text-kampmeyer-neutral-500">
          {files.length} Bild{files.length === 1 ? "" : "er"} {mode === "single" ? "gewählt" : "gefunden"} · {totalMB.toFixed(1)} MB insgesamt
        </p>
        {mode === "single" ? (
          <>
            <p className="text-sm text-kampmeyer-neutral-600 mt-2 leading-relaxed">
              Dein Bild wird auf <strong>4:3</strong> zugeschnitten und verkleinert (längste Seite
              max. 2500 Pixel) und als optimierte <strong>Kopie heruntergeladen</strong>. Dein
              Original bleibt unverändert.
            </p>
            <p className="text-sm text-kampmeyer-neutral-500 mt-1 leading-relaxed">
              Die Verarbeitung passiert komplett auf deinem Computer – es wird nichts ins Internet
              hochgeladen. Das Ergebnis landet in deinem Download-Ordner.
            </p>
          </>
        ) : (
          <>
            <p className="text-sm text-kampmeyer-neutral-600 mt-2 leading-relaxed">
              Deine Bilder werden auf <strong>4:3</strong> zugeschnitten und verkleinert (längste Seite
              max. 2500 Pixel) und als optimierte <strong>Kopien</strong> im neuen Unterordner{" "}
              <code className="text-xs bg-kampmeyer-neutral-100 px-1.5 py-0.5 rounded">00_Skaliert</code>{" "}
              gespeichert. Deine Originale bleiben unverändert.
            </p>
            <p className="text-sm text-kampmeyer-neutral-500 mt-1 leading-relaxed">
              {mode === "local"
                ? "Der Ordner „00_Skaliert“ wird direkt in deinem ausgewählten Ordner angelegt. Die Verarbeitung passiert komplett auf deinem Computer – es wird nichts ins Internet hochgeladen."
                : "Der Ordner „00_Skaliert“ wird direkt in deinem SharePoint-/OneDrive-Ordner angelegt, dort landen auch die verkleinerten Kopien."}
            </p>
          </>
        )}
        <details className="text-sm text-kampmeyer-neutral-500 mt-2">
          <summary className="cursor-pointer select-none hover:text-kampmeyer-neutral-700">
            Technische Details
          </summary>
          <p className="mt-1">
            Seitenverhältnis 4:3 · längste Kante max. 2500 px · JPEG, Qualität 80 · max. 1 MB pro
            Datei (bei sehr detailreichen Bildern wird die Qualität dafür minimal gesenkt) · 150 ppi
            · Farbraum sRGB
          </p>
        </details>
      </div>

      {files.length === 0 ? (
        <div className="text-sm text-kampmeyer-neutral-500 py-8 text-center">
          Keine Bilder (JPG, PNG, WebP oder HEIC) im Ordner gefunden.
        </div>
      ) : (
        showFiles && (
          <div className="max-h-72 overflow-y-auto border border-kampmeyer-neutral-100 rounded">
            <table className="w-full text-sm">
              <tbody>
                {files.map((f) => (
                  <tr key={f.name} className="border-b border-kampmeyer-neutral-100 last:border-b-0">
                    <td className="px-3 py-2 truncate">{f.name}</td>
                    <td className="px-3 py-2 text-right text-kampmeyer-neutral-500 w-24">
                      {(f.size / 1024 / 1024).toFixed(1)} MB
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
